module.exports = __webpack_public_path__ + "img/logo.35664cb3.png";